<template>
  <div class="w100 pl10 pt10 pr10 pb10 h100 bigbox">
 <div class="title">
      年度考核评选结果
    </div>
    <div  class="seachCla">
    <Sift
      ref="needSift"
      :sift-data="siftData"
      v-if="siftData.length"
      @change="initPage"
    >
      <el-col class="flex-box al-c" :span="6">
        <el-button class="mb10 ml10" type="primary" @click="initPage"
          >查询</el-button
        >
        <el-button class="mb10 ml10" type="primary" @click="reset"
          >重置</el-button
        >
        <el-button class="mb10 ml10" type="primary" @click="downloadTemplate"
          >模板下载</el-button
        >
        <el-button class="mb10 ml10" type="primary" @click="importExcel"
          >导入</el-button
        >
      </el-col>
    </Sift>
    </div>
    <div class="table-con">
    <el-table
      class="table"
      header-row-class-name="table-head"
      row-class-name="cu-p"
      stripe
      :data="tableData"
      v-loading="loading"
    >
      <el-table-column align="center" label="序号" width="50px">
        <template slot-scope="scope">{{
          current * size - size + scope.$index + 1
        }}</template>
      </el-table-column>
      <el-table-column
        prop="yearCheckTime"
        label="年份"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="yearCheckNatureDesc"
        label="聘用性质"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="yearCheckResultDesc"
        label="考评结果"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="toDetails(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination
        background
        @current-change="changePage"
        :current-page="current"
        :page-size="size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <Detail :detailData="detailData" :detailList="detailList" />
    <importExcel
      ref="uplodModal"
      :uplodData="uplodData"
      @closeUplod="closeUplod"
      @successCallBack="saveSuccess"
      url="/hallportal/hq/yearCheck/export"
    ></importExcel>
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import { yearCheckList , downloadTemp } from "@/api/management/staff";
import Detail from "./details.vue";
import importExcel from "@/components/dialog/import/importExcel.vue";
export default {
  name: "search",
  components: {
    Sift,
    Detail,
    importExcel,
  },
  props: [],
  data() {
    return {
      uplodData: {
        state: false,
        type: "",
      },
      siftData: [
        {
          col: 6,
          type: "year",
          key: "yearCheckTime",
          label: "年份",
          placeholder: "请选择年份",
          default: "",
          sysDatasourceQuery: "yyyy",
        },
        {
          type: "select",
          key: "yearCheckResult",
          label: "考评结果",
          placeholder: "请选择考评结果",
          default: "",
          col: 6,
          data: [
            {
              value: "0",
              label: "优秀等次",
            },
            {
              value: "1",
              label: "合格等次",
            },
            {
              value: "2",
              label: "不合格等次",
            },
            {
              value: "3",
              label: "不确定等次",
            },
          ],
        },
        {
          type: "text",
          key: "userName",
          label: "姓名",
          placeholder: "请输入姓名",
          default: "",
          col: 6,
        },
      ],
      loading: false,
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      detailData: {
        state: false,
      },
      detailList: {
        userName: "",
        list: [],
      },
    };
  },
  computed: {},
  created() {
    this.$nextTick(() => {
      this.initPage();
    });
  },
  mounted() {},
  methods: {
    reset(){
      // 清空输入框
      this.$refs.needSift.resetvalue()
      this.initPage()
    },
    initPage() {
      this.current = 1;
      this.getList();
    },
    changePage(page) {
      this.current = page;
      this.getList();
    },
    async getList() {
      this.loading = true;
      let searchData = this.$refs.needSift.getValue();
      const params = {
        ...searchData,
        current: this.current,
        size: this.size,
      };
      const { data } = await yearCheckList(params);
      this.loading = false;
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.total = data.data.total;
      } else {
        this.$message.error(data.msg);
      }
    },
    // 详情
    async toDetails(row) {
      this.detailData.state = true;
      const params = {
        current: 1,
        size: 10,
        userId: row.userId,
      };
      this.detailList.userName = row.userName;
      const { data } = await yearCheckList(params);
      if (data.code == 0) {
        if (data.data.records.length <= 3) {
          this.detailList.list = data.data.records;
        } else {
          this.detailList.list = data.data.records.slice(0, 3);
        }
      }
    },
    closeUplod(val) {
      this.uplodData.state = val;
    },
    saveSuccess() {
      this.initPage();
    },
    importExcel() {
      this.uplodData.state = true;
    },
    // 模板下载
    downloadTemplate() {
      this.downloadFn(downloadTemp());
    },
    downloadFn(url) {
      this.$DownLoad(
        url,
        null,
        (res) => {
          if (res.status != 200) {
          
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        },
        (error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.bigbox{
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-con{
    margin-top: 10px;
  background-color: white;
  flex: 1;
}

.seachCla{
  padding: 20px 20px 10px 20px;
    background-color: #ffffff;
    width: 100%;
}
}


/deep/.el-table {
  width: 100%;
  // height: 100%;
  .el-table__body-wrapper {
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
}
.title{
  padding: 0px 0px 10px 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
